// Primary navigation + footer structure — 01_MASTER_BUILD_BRIEF.md §Primary navigation / §Global footer.
// Routes follow 03_CONTENT_AND_MIGRATION.md §Proposed route convention. Unbuilt routes render ComingSoonPage.
export const CALENDLY_URL =
  "https://calendly.com/mattbroomhall/consultation?hide_event_type_details=1&hide_gdpr_banner=1&primary_color=ff3356";
// Signed-in clients book the shorter "client connect" slot
export const PORTAL_CALENDLY_URL =
  "https://calendly.com/mattbroomhall/clientconnect?hide_event_type_details=1&hide_gdpr_banner=1&primary_color=ff3356";
export const PHONE = "780-900-2495";
export const PHONE_TEL = "tel:7809002495";
export const PHONE_SMS = "sms:+15878050761";
export const EMAIL = "sayhello@hellomortgage.ca";
export const LOGO = "/brand/hello-mortgage-team-logo-transparent.png";

export const EXTERNAL_TOOLS = {
  plan: "/first-home-plan/",
  renewal: "/renewal-checker/",
  relief: "/payment-relief/",
  clientPortal: "https://matt-broom-hall.mtg-app.com/login",
};

const sol = (s) => `/mortgages/${s}/`;

export const CLIENT_LOGIN_HREF = "/client-login/";
export const REALTOR_LOGIN_HREF = "/partner-portal/";

// Menu item shape: [label, href, description?]. Groups may carry a `label` heading and `cols` (wide menus).
export const NAV = [
  {
    label: "Homebuyer",
    wide: true,
    groups: [
      { label: "Getting started", items: [
        ["How It Works", "/how-it-works/", "From hello to house keys, every step"],
        ["Budget Boost", "/calculators/budget-boost/", "Find the house hiding in your spending"],
        ["Pre-Approval", sol("pre-approval"), "Shop with a number you can trust"],
        ["First-Time Home Buyers", sol("first-time-home-buyers"), "Programs, down payment, the whole game plan"],
        ["Buy a Home", sol("buy-a-home"), "Moving up, moving on, moving in"],
        ["Investment Properties", sol("investment-properties"), "Rentals that actually pencil out"],
        ["RateWatch+", "/how-it-works/#rate-hold", "Rates drop before closing? We chase the lower one"],
      ] },
      { label: "Who you are", items: [
        ["Self-Employed", sol("self-employed-mortgages")], ["Healthcare Workers", sol("healthcare-workers")], ["Educators", sol("educators")],
        ["Restaurant & Retail Employees", sol("restaurant-and-retail-employees")], ["New to Canada", sol("new-to-canada")], ["2SLGBTQI+ Mortgages", sol("lgbtq-mortgages")],
        ["All mortgage solutions", "/mortgages/"],
      ] },
    ],
  },
  {
    label: "Homeowner",
    wide: true,
    groups: [
      { label: "Your next move", items: [
        ["Renew a Mortgage", sol("renew-a-mortgage"), "Don’t sign the bank’s first offer"],
        ["Refinance a Mortgage", sol("refinance-a-mortgage"), "Better rate, better terms, or both"],
        ["Payment Relief", sol("debt-consolidation"), "One payment. One plan. Way less stress"],
        ["Spousal & Family Buyouts", sol("spousal-buyout"), "Keep the house through a life change"],
        ["Mortgage Protection", sol("mortgage-protection"), "If life goes sideways, your family keeps the house"],
      ] },
      { label: "After closing (included)", items: [
        ["After Closing", "/after-closing/"], ["Monthly Homeowner Reports", "/after-closing/#homeowner-reports"], ["Renewal Defense", "/after-closing/#renewal-defense"], ["Annual Mortgage Review", "/after-closing/#annual-review"],
        ["Yearly Mortgage Checkup", "/tools/yearly-mortgage-checkup/"], ["Renewal Reminder", "/tools/renewal-reminder/"], ["Cash Flow Optimizer", "/calculators/cash-flow-optimizer/"],
      ] },
    ],
  },
  {
    label: "Rates",
    wide: true,
    cols: 3,
    groups: [
      { label: "Today’s best rates", items: [
        ["Live rate board", "/rates", "Updated daily across 50+ lenders"],
        ["5-year fixed", "/rates/5-yr-fixed", "Canada’s most popular term"],
        ["5-year variable", "/rates/5-yr-variable", "Moves with prime"],
        ["3-year fixed", "/rates/3-yr-fixed", "Shorter lock, lower break cost"],
      ] },
      { label: "Rates by goal", items: [
        ["First-time buyer rates", "/rates/first-time-buyers/", "Insured rates from 5% down"],
        ["Renewal rates", "/rates/renewals/", "Beat your bank’s renewal offer"],
        ["Refinance rates", "/rates/refinance/", "Consolidate · renovate · unlock equity"],
      ] },
      { label: "Rates near you", items: [
        ["Edmonton", "/edmonton/mortgage-rates/"], ["Calgary", "/calgary/mortgage-rates/"], ["Red Deer", "/red-deer/mortgage-rates/"],
        ["Lethbridge", "/lethbridge/mortgage-rates/"], ["All Alberta cities", "/locations/"],
      ] },
    ],
    callout: { title: "Rates are the headline. Strategy is the story.", text: "We compare the whole mortgage — penalties, portability, prepayment — not just the number.", href: "/how-it-works/#rate-hold", cta: "How RateWatch+ works" },
  },
  {
    label: "Tools & Smarts",
    wide: true,
    cols: 3,
    groups: [
      { label: "Calculators", items: [
        ["Mortgage Payment", "/calculators/mortgage-payment/", "What it really costs, every two weeks or every month"],
        ["Affordability", "/calculators/affordability/", "Your real number — stress test already baked in"],
        ["Closing Costs", "/calculators/closing-costs/", "The stuff nobody warns you about, totalled"],
        ["Budget Boost", "/calculators/budget-boost/", "Find the house hiding in your spending"],
        ["Cash Flow Optimizer", "/calculators/cash-flow-optimizer/", "Debt, mortgage or invest? Let the math referee"],
        ["Deal Analyzer", "/calculators/deal-analyzer/", "Is that rental a deal? Buy, borderline or walk — in 60 seconds"],
        ["All calculators", "/calculators/", "Every number you’re curious about, no spreadsheet"],
      ] },
      { label: "Apps", items: [
        ["First Home Strategy Plan", EXTERNAL_TOOLS.plan, "Your step-by-step path from renting to keys"],
        ["Renewal Checker", EXTERNAL_TOOLS.renewal, "Is the bank’s offer actually good? Find out fast"],
        ["Payment Relief Blueprint", EXTERNAL_TOOLS.relief, "Breathing room when the payment’s too tight"],
        ["Yearly Mortgage Checkup", "/tools/yearly-mortgage-checkup/", "Two minutes. Is your mortgage still the right fit?"],
        ["Renewal Reminder", "/tools/renewal-reminder/", "We’ll nudge you before the bank does"],
      ] },
      { label: "Learn", items: [
        ["Strategy Vault", "/strategy-vault/", "Straight talk on mortgages, minus the jargon"],
        ["Mortgage Playbooks", "/playbooks/", "Free guides for the move you’re making"],
        ["Mortgage Glossary", "/resources/glossary/", "Mortgage-speak, translated into human"],
        ["FAQs", "/resources/faqs/", "The questions everyone asks — and should"],
      ] },
    ],
  },
  {
    label: "About Us",
    groups: [{ items: [
      ["Our Story", "/why-hello/#story"], ["How It Works", "/how-it-works/"], ["Guiding Principles", "/why-hello/#principles"], ["The Experience", "/why-hello/#experience"], ["Kindness Matters Most", "/why-hello/#kindness"], ["Homeownership for Everyone", "/why-hello/#for-all"],
      ["Reviews & Client Stories", "/why-hello/reviews/"], ["Contact", "/contact/"],
    ] }],
  },
  {
    label: "Partners",
    groups: [{ items: [
      ["For Realtors", "/realtor-partners/", "Why partner with us — and sign up"],
      ["Realtor Login", REALTOR_LOGIN_HREF, "Submit clients, feature sheets, embeds"],
    ] }],
  },
];

export const FOOTER_COLUMNS = [
  { title: "Calculators", aria: "Mortgage calculators", links: [
    ["Mortgage payment calculator", "/calculators/mortgage-payment/"], ["Mortgage affordability calculator", "/calculators/affordability/"],
    ["Closing costs calculator", "/calculators/closing-costs/"], ["Budget Boost", "/calculators/budget-boost/"],
    ["Cash Flow Optimizer", "/calculators/cash-flow-optimizer/"], ["All mortgage calculators", "/calculators/"],
  ] },
  { title: "Resources", aria: "Mortgage resources", links: [
    ["Today’s mortgage rates", "/rates"], ["Strategy Vault", "/strategy-vault/"], ["Mortgage Playbooks", "/playbooks/"],
    ["Yearly Mortgage Checkup", "/tools/yearly-mortgage-checkup/"], ["Renewal Reminder", "/tools/renewal-reminder/"], ["Mortgage glossary", "/resources/glossary/"], ["Frequently asked questions", "/resources/faqs/"],
  ] },
  { title: "Company", aria: "About Hello Mortgage", links: [
    ["About Hello Mortgage", "/why-hello/#story"], ["Meet the team", "/why-hello/#team"], ["Client reviews", "/why-hello/reviews/"],
    ["Locations across Alberta", "/locations/"], ["Homes for sale", "/listings/"], ["Client Login", CLIENT_LOGIN_HREF], ["Contact Hello Mortgage", "/contact/"],
  ], sub: { title: "Partners", links: [["For Realtors", "/realtor-partners/"], ["Realtor Login", REALTOR_LOGIN_HREF]] } },
];

// Local directory (above footer) — Alberta homepage variant. Source copy preserved.
export const ALBERTA_CITIES = [
  ["Edmonton", "/edmonton/"], ["Calgary", "/calgary/"], ["Sherwood Park", "/sherwood-park/"], ["Leduc", "/leduc/"],
  ["St. Albert", "/st-albert/"], ["Red Deer", "/red-deer/"], ["Lethbridge", "/lethbridge/"], ["Fort McMurray", "/fort-mcmurray/"],
  ["Grande Prairie", "/grande-prairie/"], ["Airdrie", "/airdrie/"], ["Cochrane", "/cochrane/"], ["Beaumont", "/beaumont/"],
  ["Medicine Hat", "/medicine-hat/"], ["Lloydminster", "/lloydminster/"], ["Fort Saskatchewan", "/fort-saskatchewan/"], ["Spruce Grove", "/spruce-grove/"],
];
export const ALBERTA_SERVICES = [
  ["First-time buyers", sol("first-time-home-buyers")], ["Mortgage pre-approval", sol("pre-approval")], ["Mortgage renewals", sol("renew-a-mortgage")],
  ["Mortgage refinancing", sol("refinance-a-mortgage")], ["Payment Relief", sol("debt-consolidation")], ["Self-employed mortgages", sol("self-employed-mortgages")],
  ["Healthcare workers", sol("healthcare-workers")], ["Teachers", sol("educators")], ["Restaurant & retail workers", sol("restaurant-and-retail-employees")], ["New to Canada", sol("new-to-canada")], ["Investment properties", sol("investment-properties")],
  ["Spousal buyout", sol("spousal-buyout")], ["2SLGBTQI+ mortgages", sol("lgbtq-mortgages")], ["Mortgage protection", sol("mortgage-protection")],
];

export const SOCIAL_LINKS = [
  ["Instagram", "https://www.instagram.com/hellomortgage.ca/"],
  ["Facebook", "https://www.facebook.com/hellomortgage.ca"],
  ["Spotify", "https://open.spotify.com/user/31lzo6gjb7bnzcgxwyas5ouji5dq"],
];

export const isExternal = (href) => /^https?:\/\//.test(href);

// Routes that still render the Coming-Soon page — hidden from menus/footer until built (launch 2026-09-21).
export const UNBUILT = new Set(["/realtor-partners/", "/partner-portal/", "/resources/glossary/", "/resources/faqs/", "/sitemap/"]);
const liveLinks = (links) => links.filter(([, h]) => !UNBUILT.has(h));
export const NAV_LIVE = NAV.map((n) => ({ ...n, groups: n.groups.map((g) => ({ ...g, items: liveLinks(g.items) })).filter((g) => g.items.length) })).filter((n) => n.groups.length);
export const FOOTER_LIVE = FOOTER_COLUMNS.map((c) => ({ ...c, links: liveLinks(c.links), sub: c.sub && liveLinks(c.sub.links).length ? { ...c.sub, links: liveLinks(c.sub.links) } : undefined }));

// Every internal site route referenced above (for ComingSoon routing until built).
export function allSiteRoutes() {
  const set = new Set();
  const add = (h) => { if (!isExternal(h)) set.add(h); };
  NAV.forEach((n) => { n.groups.forEach((g) => g.items.forEach(([, h]) => add(h))); if (n.callout) add(n.callout.href); });
  FOOTER_COLUMNS.forEach((c) => c.links.forEach(([, h]) => add(h)));
  ALBERTA_CITIES.forEach(([, h]) => add(h)); ALBERTA_SERVICES.forEach(([, h]) => add(h));
  ["/privacy/", "/sitemap/", "/contact/"].forEach(add);
  return [...set];
}
